/* A separate Storefront API cart keeps the customer's storefront cart intact. */
(() => {
  'use strict';
  function init() {
    const root = document.querySelector('[data-retailer-product]');
    const form = root?.querySelector('[data-retailer-form]');
    const config = window.RetailerCommerce;
    if (!root || !form || !config || form.dataset.checkoutInitialized) return;
    form.dataset.checkoutInitialized = 'true';
    const select = form.querySelector('[data-retailer-variant]');
    const quantity = form.querySelector('[data-retailer-quantity]');
    const status = root.querySelector('[data-retailer-status]');
    const message = (text) => {
      if (!status) return;
      status.hidden = false;
      status.textContent = text;
    };
    const copy = config.messages?.commerce || {};
    const marketLanguages = {DE:'DE',AT:'DE',HU:'HU',CZ:'CS',PT:'PT_PT',PL:'PL'};
    let busy = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      if (config.countrySoldOut === true) {
        message('Dieser Artikel ist in Österreich derzeit ausverkauft.');
        return;
      }
      const countries = [...new URL(location.href).searchParams].filter(([key]) => key.toLowerCase() === 'country');
      if (!config.allowedCountries?.includes(config.country) || config.marketReady !== true || countries.some(([, value]) => value.toUpperCase() !== config.country)) {
        message(copy.country_error || "Dieses Produkt ist in Deutschland, Österreich, Ungarn, Tschechien und Portugal erhältlich.");
        return;
      }
      const selectedId = String(select?.value || '');
      const selected = (config.variants || []).find(variant => String(variant.id) === selectedId);
      const count = Number(quantity?.value || 1);
      if (!selected?.available || config.releaseReady !== true || config.pricingUnverified === true) {
        message(copy.unavailable || "Diese Ausführung ist derzeit nicht für den Checkout freigegeben.");
        return;
      }
      if (!Number.isInteger(count) || count !== 1) {
        message(copy.limit || "Maximal 1 Gerät pro Bestellung.");
        return;
      }
      busy = true;
      const controls = [...root.querySelectorAll('button,select,input')].map(node => ({ node, disabled: node.disabled }));
      controls.forEach(({ node }) => node.disabled = true);
      root.querySelectorAll('[data-retailer-checkout]').forEach(node => node.setAttribute('aria-busy', 'true'));
      message(copy.opening || "Checkout wird geöffnet…");
      try {
        const response = await fetch(config.endpoint || '/api/2026-10/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: 'mutation RetailerCart($input:CartInput!,$country:CountryCode!,$language:LanguageCode!) @inContext(country:$country,language:$language){cartCreate(input:$input){cart{id checkoutUrl lines(first:10){nodes{quantity merchandise{... on ProductVariant{id}}}} cost{totalAmount{amount currencyCode}}} userErrors{field message code}}}',
            variables: {
              country: config.country, language: marketLanguages[config.country],
              input: {
                lines: [{ merchandiseId: `gid://shopify/ProductVariant/${selectedId}`, quantity: count }],
                buyerIdentity: { countryCode: config.country },
                attributes: [{ key: 'expected_delivery_country', value: config.country }]
              }
            }
          })
        });
        const result = await response.json();
        const created = result.data?.cartCreate;
        const cart = created?.cart;
        if (!response.ok || result.errors?.length || created?.userErrors?.length || !cart?.checkoutUrl
          || cart.cost?.totalAmount?.currencyCode !== config.currency
          || cart.lines?.nodes?.length !== 1 || cart.lines.nodes[0].quantity !== count
          || cart.lines.nodes[0].merchandise?.id !== `gid://shopify/ProductVariant/${selectedId}`) {
          throw new Error('Unexpected checkout response');
        }
        const destination = new URL(cart.checkoutUrl);
        const checkoutHosts = new Set(['cjuuri.shop', 'x58tw0-qu.myshopify.com']);
        const checkoutPath = /^\/checkouts\/[a-z0-9_-]+(?:\/|$)/i.test(destination.pathname)
          || /^\/(?:(?:de|hu|cs|pt|pt-pt|pl)\/)?cart\/c\/[a-z0-9_-]+\/?$/i.test(destination.pathname)
          || destination.pathname === '/checkout';
        if (destination.protocol !== 'https:' || destination.username || destination.password
          || !checkoutHosts.has(destination.hostname) || !checkoutPath) {
          throw new Error('Unexpected checkout origin');
        }
        destination.searchParams.set('locale', config.locale);
        location.assign(destination.href);
      } catch {
        message(copy.error || "Der Checkout konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.");
        controls.forEach(({ node, disabled }) => node.disabled = disabled);
        root.querySelectorAll('[data-retailer-checkout]').forEach(node => node.removeAttribute('aria-busy'));
        busy = false;
      }
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
